<form [formGroup]="loginForm">
  <div *ngIf="!passwordLost && !pinLost" class="text-center">
    <ng-container *ngIf="online">
      <div>
        <label>
          {{ "login.email" | i18next }}<br />
          <input
            (change)="setUsername($event.target)"
            autocomplete="username"
            class="form-control login-input"
            formControlName="email"
            placeholder="{{ 'login.email' | i18next }}"
            type="email"
          />
        </label>
      </div>
      <div>
        <label style="position: relative">
          {{ "login.password" | i18next }}<br />
          <input
            (change)="setPassword($event.target)"
            autocomplete="current-password"
            class="form-control login-input"
            formControlName="password"
            placeholder="{{ 'login.password' | i18next }}"
            [type]="passwortInputType()"
          />
          <button
            type="button"
            class="eye-position"
            (click)="togglePasswordVisible()"
          >
            <img
              *ngIf="!passwortVisible"
              class="my-auto"
              src="./assets/img/Auge.svg"
            />
            <img
              *ngIf="passwortVisible"
              class="my-auto"
              style="transform: translateY(1px)"
              src="./assets/img/Auge_ausgeblendet.svg"
            />
          </button>
        </label>
      </div>
      <button
        (click)="handleLogin()"
        [disabled]="!loginForm.valid"
        class="btn primary full"
      >
        {{ "login.login" | i18next }}
      </button>
    </ng-container>
    <!--<button (click)="debugThisBoi()">simsalabim</button>-->
    <div>
      <div>
        <a *ngIf="biometric" [routerLink]="['/auth/biometric']">{{
          "biometric.login" | i18next
        }}</a
        ><br />
        <br />
        <a
          *ngIf="!(nis.isNative$ | async)"
          href="{{ supportUrlLangRelated }}"
          target="_blank"
          >{{ "login.password-lost" | i18next }}</a
        >
        <a
          (click)="openBrowser()"
          *ngIf="nis.isNative$ | async"
          target="_blank"
          >{{ "login.password-lost" | i18next }}</a
        >
        <br />
        <br />
        <app-lang-switcher></app-lang-switcher>
      </div>
    </div>
  </div>
</form>

<div class="app-info">
  <small>Version: v{{ currentApplicationVersion }}</small
  ><br />
</div>
